<template>
  <div name="demo-validate-required-all-when-not-exist-any">
    <hrms-timepicker  v-model="timstrt" 
                      v-validate="'requiredAllWhenNotExistAny:timstrt-timend,dtestrt-dteend|date_format:HH:mm'"
                      data-vv-value-path="inputTime"
                      data-vv-name="timstrt"
                      name="timstrt"
                      :has-error="errors.has('timstrt')" />
    <div class="text-error" v-show="errors.has('timstrt')">{{errors.first('timstrt')}}</div>

    <hrms-timepicker  v-model="timend" 
                      v-validate="'requiredAllWhenNotExistAny:timstrt-timend,dtestrt-dteend|date_format:HH:mm'"
                      data-vv-value-path="inputTime"
                      data-vv-name="timend"
                      name="timend"
                      :has-error="errors.has('timend')" />
    <div class="text-error" v-show="errors.has('timend')">{{errors.first('timend')}}</div>

    <hrms-datepicker  v-model="dtestrt" 
                      v-validate="'date_format:DD/MM/YYYY'"
                      data-vv-value-path="inputDate"
                      data-vv-name="dtestrt"
                      name="dtestrt"
                      :has-error="errors.has('dtestrt')" />
    <div class="text-error" v-show="errors.has('dtestrt')">{{errors.first('dtestrt')}}</div>

    <hrms-datepicker  v-model="dteend" 
                      v-validate="'date_format:DD/MM/YYYY'"
                      data-vv-value-path="inputDate"
                      data-vv-name="dteend"
                      name="dteend"
                      :has-error="errors.has('dteend')" />
    <div class="text-error" v-show="errors.has('dteend')">{{errors.first('dteend')}}</div>
    <button @click="validateFields()">Save</button>
  </div>
</template>

<script>
export default {
  name: 'demo-validate-required-all-when-not-exist-any',
  data () {
    return {
      timstrt: '',
      timeend: '',
      dtestrt: '',
      dteend: ''
    }
  },
  methods: {
    validateFields () {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            console.log('validate pass')
          }
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoValidateRequiredAllWhenNotExistAny.vue?7836bcfd